module.exports = __webpack_public_path__ + "img/template5.f3faf472.png";